module.exports = __webpack_public_path__ + "static/media/PALAMOA_bl.f794e394.svg";